import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Myra= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
             Hero Head
                <br />
                <Typography component="span" variant="inherit" color="primary">
           Myra
                </Typography>
              </span>
            }
            subtitle="Myra is the first compact liquid handling system with an integrated camera and state of the art algorithms. It automates and simplifies pipette calibration and monitors for user errors in deck layout such as missing tubes. 
            "
            align="left"
            disableGutter
            titleVariant="h3"

            />
            <ul>
                <li>
                World's first robotic liquid handling system with a built-in miniature camera.
                </li>

                <li>
                Ability to view and position the pipette head to insert directly into the center of the tip well.

                </li>
                <li>
            	Pipette head optimized for multi-dispensing and tip-reuse for faster sample loading.
                </li>
                <li>
                Comes complete with UV LED lights and HEPA filter to ensure a clean qPCR workstation

                </li>
                <li>
                Pressure based liquid level sensor will alert user of any aspirating and dispensing errors

                </li>

                <li>
                Interchangeable pipette allows flexibility and accuracy with your workflow
                </li>

                <li>
                Compact and lightweight design allows instrument to fit perfectly in any qPCR setting

                </li>

                <li>
                Future Proof: Myra has been designed for easy upgradeability.

                </li>

                <li>
                	Pipetting volume (µL): 1-50
                </li>

                <li>
                Connections: USB 2.0
                </li>
                <li>
                	Dimensions (W x D x H) (mm): 360 x 460 x 310 (360 x 460 x 610 with lid lifted up)
                </li>

                <li>
                Weight: 10 kg
                </li>
                <li>
                Warranty: 2 years
                </li>
            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/Myra_PkDVsLv7sw.png?updatedAt=1628243549324"
            alt="Myra"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Myra.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Myra;
